import type { SnapshotId } from '@ipfabric/utils';
import { makeSelectedSnapshot } from 'pages/SnapshotManagement/selectors';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';

type UseSnapshotIdHook = SnapshotId | null;

interface SelectorProps {
  snapshotId: SnapshotId | null;
}

const selector = createStructuredSelector({
  snapshotId: makeSelectedSnapshot(),
});

export const useSnapshotId = (): UseSnapshotIdHook =>
  useSelector<unknown, SelectorProps>(selector).snapshotId;
